

import Page from "../component/Page";
import { Box, Button, ButtonGroup, Container, Typography } from "@mui/material";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import { useState } from "react";

export default function SevereWeatherClimate() {
    const [event, setEvent] = useState("Hail");

    return <Page>
        <Container sx={{ py: 5 }}>
            <NextBreadcrumbs></NextBreadcrumbs>
            <Box sx={{ display: "flex", justifyContent: "space-between", pt: 5, flex: 1 }}>
                <Typography variant="h4" gutterBottom>
                    {event.replace("_", " ")} Data
                </Typography>
                <ButtonGroup >
                    <Button variant="contained" disabled={event === "Hail"} onClick={() => { setEvent("Hail") }}>Hail</Button>
                    <Button variant="contained" disabled={event === "Thunderstorm_Wind"} onClick={() => { setEvent("Thunderstorm_Wind") }}>ThunderStorm Wind</Button>
                    <Button variant="contained" disabled={event === "Tornado"} onClick={() => { setEvent("Tornado") }}>Tornado</Button>
                </ButtonGroup>
            </Box>

            <iframe
                src={`https://sw.kymeso.net/embed/table/${event}`}
                style={{ "width": "100%", minHeight: 800, maxHeight: 1200, border: 0, }}
            ></iframe>

        </Container>
    </Page>

}